import { getPermissions } from 'utils/permissions';

export const selectAuth = (state) => state.auth;
export const selectCurrentUser = (state) => state.auth.user;
export const selectIsAuthenticated = (state) => state.auth.isAuthenticated;
export const selectAuthStatus = (state) => state.auth.status;
export const selectIsRestoring = (state) => state.auth.status === 'restoring';
export const selectLoginLoading = (state) => state.auth.loginLoading;
export const selectAuthError = (state) => state.auth.error;
export const selectRoleName = (state) => state.auth.user?.roleName || null;
export const selectUserPermissions = (state) => getPermissions(state.auth.user);
